import * as React from "react"

import { NavDocuments } from "@/components/nav-documents"
import { NavMain } from "@/components/nav-main"
import { NavSecondary } from "@/components/nav-secondary"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  CommandIcon,
  LayoutDashboardIcon,
  ClipboardListIcon,
  FolderIcon,
  SearchIcon,
  CircleHelpIcon,
  Settings2Icon,
  FileTextIcon,
  FolderOpenIcon,
  DatabaseIcon,
} from "lucide-react"

type SidebarUser = {
  name: string
  email: string
  avatar?: string
}

export function AppSidebar({
  user,
  role,
  onLogout,
  ...props
}: React.ComponentProps<typeof Sidebar> & {
  user: SidebarUser
  role?: string
  onLogout?: () => void
}) {
  const isSysAdmin = role === "system_admin"
  const isAdmin = role === "administrator" || role === "system_admin"

  const navMain = isSysAdmin
    ? [
        {
          title: "Gestión de Usuarios",
          url: "/system-admin/panel",
          icon: <LayoutDashboardIcon />,
          isActive: !window.location.pathname.includes("logs") && !window.location.pathname.includes("db"),
        },
        {
          title: "Reportes y Estadísticas",
          url: "/admin/dashboard/reports",
          icon: <DatabaseIcon />,
          isActive: window.location.pathname.includes("reports"),
        }
      ]
    : isAdmin 
    ? [
        {
          title: "Bandeja de Solicitudes",
          url: "/admin/dashboard",
          icon: <LayoutDashboardIcon />,
          isActive: !window.location.pathname.includes("reports"),
        },
        {
          title: "Reportes y Estadísticas",
          url: "/admin/dashboard/reports",
          icon: <DatabaseIcon />,
          isActive: window.location.pathname.includes("reports"),
        }
      ]
    : [
        {
          title: "Panel del afiliado",
          url: "/affiliate/dashboard",
          icon: <LayoutDashboardIcon />,
          isActive: true,
        },
        {
          title: "Nueva solicitud",
          url: "/affiliate/dashboard/new",
          icon: <ClipboardListIcon />,
        },
        {
          title: "Mis solicitudes",
          url: "/affiliate/dashboard/history",
          icon: <FolderIcon />,
        },
      ]

  const navSecondary = [
    {
      title: "Buscar",
      url: "#",
      icon: <SearchIcon />,
    },
    {
      title: "Ayuda",
      url: "#",
      icon: <CircleHelpIcon />,
    },
    {
      title: "Configuracion",
      url: "#",
      icon: <Settings2Icon />,
    },
  ]

  const documents = isSysAdmin 
    ? []
    : isAdmin 
    ? [
        {
          name: "Guía de Revisión",
          url: "#",
          icon: <FileTextIcon />,
        }
      ]
    : [
        {
          name: "Requisitos por beneficio",
          url: "#requisitos",
          icon: <FileTextIcon />,
        },
        {
          name: "Documentos subidos",
          url: "#documentos-subidos",
          icon: <FolderOpenIcon />,
        },
        {
          name: "Historial de tramites",
          url: "#mis-solicitudes",
          icon: <DatabaseIcon />,
        },
      ]

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton className="data-[slot=sidebar-menu-button]:p-1.5!" render={<a href={isSysAdmin ? "/system-admin/panel" : isAdmin ? "/admin/dashboard" : "/affiliate/dashboard"} />}>
              <CommandIcon className="size-5!" />
              <span className="text-base font-semibold">INSESO Portal</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
        {documents.length > 0 && <NavDocuments items={documents} />}
        <NavSecondary items={navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name: user.name,
            email: user.email,
            avatar: user.avatar ?? "/avatars/inseso.png",
          }}
          onLogout={onLogout}
        />
      </SidebarFooter>
    </Sidebar>
  )
}
